import en from "@content/locales/en.json";
import es from "@content/locales/es.json";
import zhHans from "@content/locales/zh-Hans.json";
import yue from "@content/locales/yue.json";
import ko from "@content/locales/ko.json";
import vi from "@content/locales/vi.json";
import criticalKeys from "@content/locales/critical-keys.json";
import {
  stripMetaKeys,
  translateKey,
} from "@content/locales/lib/critical-i18n-policy.mjs";
import {
  isLanguageSelectable,
  languagesConfig,
} from "./languages";

export type LocaleTable = Record<string, string>;

const localeModules: Record<string, LocaleTable> = {
  en: en as LocaleTable,
  es: es as LocaleTable,
  "zh-Hans": zhHans as LocaleTable,
  yue: yue as LocaleTable,
  ko: ko as LocaleTable,
  vi: vi as LocaleTable,
};

const criticalKeySet = new Set(criticalKeys.criticalKeys as string[]);
const englishTable = stripMetaKeys(localeModules.en);

export function loadLocale(code: string): LocaleTable {
  if (!isLanguageSelectable(code)) {
    return englishTable;
  }
  const raw = localeModules[code] ?? localeModules.en;
  const table = stripMetaKeys(raw);
  // Critical keys must exist in locale file (validated in CI). No silent English fallback.
  for (const key of criticalKeySet) {
    if (!(key in table) || String(table[key]).trim() === "") {
      if (import.meta.env.DEV) {
        console.warn(
          `[i18n] Missing critical key "${key}" in ${code}; validation should have caught this.`,
        );
      }
    }
  }
  return table;
}

export function t(table: LocaleTable, key: string): string {
  return translateKey(table, key, criticalKeySet, englishTable);
}

export function getDefaultLanguageCode(): string {
  return languagesConfig.defaultLanguage;
}
